import React from "react";

const DocumentSelector = ({ index, documentType = "CIN", setDocumentType }) => {
  const handleChange = (event) => {
    setDocumentType(event.target.value);
  };

  const documents = [
    { name: "CIN", value: "CIN" },
    { name: "Passeport", value: "Passeport" },
    { name: "Permis", value: "Permis" },
    { name: "Visa", value: "Visa" },
  ];

  return (
    <div style={{ padding: "20px", border: "1px solid #ccc" }}>
      <h3>Choisir le type de document :</h3>
      <div style={{ marginTop: "10px" }}>
        {documents.map((doc, idx) => (
          <label key={idx} style={{ marginLeft: idx === 0 ? 0 : "10px" }}>
            <input
              type="radio"
              name={`documentType${index}`}
              value={doc.value}
              checked={documentType === doc.value}
              onChange={handleChange}
            />
            {doc.name}
          </label>
        ))}
      </div>
    </div>
  );
};

export default DocumentSelector;
